import { render, staticRenderFns } from "./LeadDetail.vue?vue&type=template&id=87b714e0&scoped=true&"
import script from "./LeadDetail.vue?vue&type=script&lang=js&"
export * from "./LeadDetail.vue?vue&type=script&lang=js&"
import style0 from "./LeadDetail.vue?vue&type=style&index=0&id=87b714e0&prod&lang=scss&scoped=true&"
import style1 from "./LeadDetail.vue?vue&type=style&index=1&id=87b714e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b714e0",
  null
  
)

export default component.exports